export default "__VITE_ASSET__588da325__"